// extracted by mini-css-extract-plugin
module.exports = {"pane":"_3lV__sRR","header":"fGBREMVc","aceEditor":"_3orMiDE-"};